import { Navigate, Outlet } from "react-router";
import { useGetProfileQuery } from "../../../redux/reducers/apiSlice";
import FullPageNexusLogoAnimation from "../../Reusable/FullPageNexusLogoAnimation/FullPageNexusLogoAnimation";

/**
 * Layout gate: only Measure Admins render nested routes (platform operations surface).
 */
const MeasureAdminRoute = () => {
  const { data: profile, isLoading } = useGetProfileQuery();

  if (isLoading) {
    return <FullPageNexusLogoAnimation />;
  }

  if (!profile?.isMeasureAdmin) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default MeasureAdminRoute;
